import { AccessFunction } from 'data/accessFunction/accessFunction.types';
import {
  TargetDeliveryTemplateAccessFunction,
  TargetDeliveryTemplateAccessFunctionRowData,
} from 'data/targetDeliveryTemplateAccessFunction/targetDeliveryTemplateAccessFunction.types';
import { FormTemplateMapByKey } from 'data/template/template.types';
import cloneDeep from 'lodash.clonedeep';

// eslint-disable-next-line import/prefer-default-export
export const adaptAccessFunctionsGridRowData = (
  data: TargetDeliveryTemplateAccessFunction[],
  accessFunctions: AccessFunction[],
  accessFunctionTemplates: FormTemplateMapByKey,
): TargetDeliveryTemplateAccessFunctionRowData[] => {

  return cloneDeep(data).map((targetTemplate) => ({
    ...targetTemplate,
    afName: accessFunctions.find((af) => af.id === targetTemplate.afId)?.name || '',
    afTypeDisplay: accessFunctionTemplates?.[targetTemplate.afType]?.name || ''
  }));
};
